import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAdminsRequest,
  fetchAdminsSuccess,
  fetchAdminsFailure,
  createAdminRequest,
  createAdminSuccess,
  createAdminFailure,
  editAdminRequest,
  editAdminSuccess,
  editAdminFailure,
  deleteAdminRequest,
  deleteAdminSuccess,
  deleteAdminFailure,
  toggleAdminStatusRequest,
  toggleAdminStatusSuccess,
  toggleAdminStatusFailure,
  fetchPermissionsRequest,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
  updatePermissionsRequest,
  updatePermissionsSuccess,
  updatePermissionsFailure,
} from "../AdminList/adminSlice";
import axios from "axios";
import { toast } from "react-toastify";

// Fetch Admins data
function* fetchAdmins(action) {
  try {
    const payload = {
      start: Number(action.payload.start ?? 0),
      limit: Number(action.payload.limit ?? 10),
      search: action.payload.search || "",
    };
    const response = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/users/userList`, {
        params: payload,
      })
    );

    const result = response.data;
    const users = result.data?.data || [];
    const total = result.data?.total || 0;
    const page = result.data?.page || 1;
    const limit = result.data?.limit || 10;

    const filteredUsers = Array.isArray(users)
      ? users.filter((user) => user.role?.toLowerCase() !== "god")
      : [];

    const data = filteredUsers.map((user, index) => ({
      id: payload.start + index + 1,
      _id: user._id,
      name: user.name,
      email: user.email,
      phone: user.phone,
      role: user.role || "-",
      userRole: user.userRole || {},
      enabled: user.enabled,
      allowAdminMobileAccess: user.allowAdminMobileAccess === true,
      referralcode: user.referralcode,
      points: user.referralpoint?.points ?? 0,
      referralpoint: user.referralpoint || null,
      countryCode: user.countryCode || null,
      createdBy: user.createdBy || "",
      updatedBy: user.updatedBy || "",
    }));

    yield put(
      fetchAdminsSuccess({
        data,
        total,
        page: Math.floor((payload.start || 0) / (payload.limit || 5)) + 1,
        limit: payload.limit || 5,
      })
    );
  } catch (error) {
    yield put(
      fetchAdminsFailure(error.response?.data?.message || error.message)
    );
  }
}

// Create Admin
function* createAdmin(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/createUser`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    yield put(createAdminSuccess(response.data));
    if (response.data.success == false) {
      toast.error(response.data.message);
    } else {
      toast.success(response.data.message);
    }
    yield put(fetchAdminsRequest({ start: 0, limit: 10 }));
  } catch (error) {
    yield put(
      createAdminFailure(error.response?.data?.message || error.message)
    );
  }
}

// Edit Admin
function* editAdmin(action) {
  try {
    const { userId, userData } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/editUser/${userId}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    yield put(editAdminSuccess(response.data));
    yield put(fetchAdminsRequest({ start: 0, limit: 10 }));
  } catch (error) {
    yield put(editAdminFailure(error.response?.data?.message || error.message));
  }
}

//  Delete Admin
function* deleteAdmin(action) {
  try {
    const adminId = action.payload;
    yield call(
      axios.delete,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/deleteUser/${adminId}`
    );

    yield put(deleteAdminSuccess(adminId));
    yield put(fetchAdminsRequest());
  } catch (error) {
    yield put(
      deleteAdminFailure(error.response?.data?.message || error.message)
    );
  }
}

function* toggleAdminStatus(action) {
  try {
    const { userId, enabled } = action.payload;
    yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/updateUserStatus/${userId}`,
      { enabled },
      { headers: { "Content-Type": "application/json" } }
    );
    yield put(toggleAdminStatusSuccess());
    yield put(fetchAdminsRequest());
  } catch (error) {
    yield put(
      toggleAdminStatusFailure(error.response?.data?.message || error.message)
    );
  }
}

function* fetchPermissions(action) {
  try {
    const { userId, jewellerId } = action.payload;
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/permissions/${userId}`,
        { jeweller: jewellerId }
      )
    );
    const result = response.data;

    if (result.success) {
      yield put(fetchPermissionsSuccess(result.data));
    } else {
      yield put(
        fetchPermissionsFailure(result.message || "Failed to fetch permissions")
      );
    }
  } catch (error) {
    yield put(
      fetchPermissionsFailure(error.response?.data?.message || error.message)
    );
  }
}

function* updatePermissions(action) {
  try {
    const { userId, permissions, role, jeweller } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/updatePermissions/${userId}`,
      { permissions, role, jeweller },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    yield put(updatePermissionsSuccess(response.data));
    yield put(fetchPermissionsRequest({ userId, jeweller }));
  } catch (error) {
    yield put(
      updatePermissionsFailure(error.response?.data?.message || error.message)
    );
  }
}

// Root Saga
export default function* adminsaga() {
  yield takeLatest(fetchAdminsRequest.type, fetchAdmins);
  yield takeLatest(createAdminRequest.type, createAdmin);
  yield takeLatest(editAdminRequest.type, editAdmin);
  yield takeLatest(deleteAdminRequest.type, deleteAdmin);
  yield takeLatest(toggleAdminStatusRequest.type, toggleAdminStatus);
  yield takeLatest(fetchPermissionsRequest.type, fetchPermissions);
  yield takeLatest(updatePermissionsRequest.type, updatePermissions);
}
